import { Component, OnInit, Optional, Inject, NgModule, EventEmitter } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AssetUploadService } from '../../../../services/asset-upload.service';

@Component({
  selector: 'add-innermapping-dialog',
  templateUrl: './add-innermapping-dialog.component.html',
  styleUrls: ['./add-innermapping-dialog.component.scss']
})


export class AddInnermappingDialogComponent implements OnInit {

  assetInnerMapping = [];
  arrInnerFileColumns = [];
  arrInnerAssetColumns = [];

  strInnerAssetColumn: string;
  strInnerFileColumn: string;
  strFileColumn: string;
  srtInnerTableColumnText: String;
  intParentMapId: number;
  loading: boolean;
  hotAlert: string;
  strAssetColumn: string;
  showHotAlertSection: boolean;
  fleetCustomerId: string;

  onUpdate = new EventEmitter();





  constructor(
    public dialogRef: MatDialogRef<AddInnermappingDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public arrInnerMappingDetails: any,
    public dialog: MatDialog, private assetUploadService: AssetUploadService
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {

    console.log("arrInnerMappingDetails===>" + JSON.stringify(this.arrInnerMappingDetails));

    this.fleetCustomerId = sessionStorage.getItem("fleetCustomerId");
    this.assetInnerMapping = this.arrInnerMappingDetails[0].innerMappingDetails;
    this.arrInnerAssetColumns = this.arrInnerMappingDetails[0].arrInnerAssetColumns;

    this.arrInnerFileColumns = this.arrInnerMappingDetails[0].arrInnerFileColumns;

    this.intParentMapId = this.arrInnerMappingDetails[0].intParentMapId;
    this.strAssetColumn = this.arrInnerMappingDetails[0].strAssetColumn;
    this.strFileColumn = this.arrInnerMappingDetails[0].strFileColumn;

    this.showHotAlertSection = false;
    if (this.strAssetColumn == "HotAlert") {
      this.arrInnerAssetColumns = [];
      this.showHotAlertSection = true;
    }

    console.log("arrInnerMappingDetails.arrInnerFileColumns===>" + JSON.stringify(this.arrInnerMappingDetails[0]['arrInnerFileColumns']));
  }

  drop(event: CdkDragDrop<string[]>) {

    console.log("event===>" + event);

    console.log("event.previousContainer.id===>" + event.previousContainer.id);


    let strInnerFileColumn = "";
    if (event.container.id === "cdkMappedInnerAssetColumnList") {

      let intPreviousIndex = event.previousIndex;
      this.strInnerAssetColumn = this.arrInnerAssetColumns[intPreviousIndex].value;
      this.srtInnerTableColumnText = this.arrInnerAssetColumns[intPreviousIndex].description;

      for (let value of this.assetInnerMapping) {
        if (value.tableColumn === this.strInnerAssetColumn) {
          alert(this.srtInnerTableColumnText + " coulmn mapped allready. \n Please drag other column.");
          return false;
        }
      }

    }

    if (event.container.id === "cdkMappedInnerFileColumnList") {
      let intPreviousIndex = event.previousIndex;
      this.strInnerFileColumn = this.arrInnerFileColumns[intPreviousIndex];
    }


    let intInnerMappedAssetColumnSize = this.assetInnerMapping.length;


    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {

      let intCurrentIndex = intInnerMappedAssetColumnSize;

      if (event.container.id === "cdkMappedInnerFileColumnList") {
        if (intCurrentIndex <= 0) {
          alert('Please drag inner asset coulmn first.');
          return false;
        } else if (this.assetInnerMapping[intCurrentIndex - 1]['innerFileColumn'] != "") {
          alert('Please drag inner asset coulmn first.');
          return false;
        }
        else {
          this.assetInnerMapping[intCurrentIndex - 1]['innerFileColumn'] = this.strInnerFileColumn;
          this.assetInnerMapping[intCurrentIndex - 1]['fileColumn'] = this.strFileColumn;

          this.addInnerAssetColumn(this.assetInnerMapping[intCurrentIndex - 1]);

        }
      } else if (event.container.id === "cdkMappedInnerAssetColumnList") {

        if (intCurrentIndex > 0 && !this.assetInnerMapping[intCurrentIndex - 1]['fileColumn']) {
          alert('Please drag inner file coulmn first.');
        } else {
          this.assetInnerMapping[intCurrentIndex] = {
            tableColumn: this.strInnerAssetColumn,
            fileColumn: "",
            defaultValue: "",
            format: "",
            isActive: 1,
            customerId: this.fleetCustomerId,
            mapId: 0,
            parentMapId: this.intParentMapId,
            isInnerMapping: 0,
            updatedBy: 0,
            innerTableColumnText: this.srtInnerTableColumnText,
            innerFileColumn: "",
            outerTableColumn: this.strAssetColumn
          };

          console.log("this.assetInnerMapping===>" + JSON.stringify(this.assetInnerMapping));
        }
      }
    }
  }

  addInnerAssetColumn(arrAssetMapping) {
    var arrInsertAssetUploadMappingData = {
      tableColumn: arrAssetMapping.tableColumn,
      customerId: arrAssetMapping.customerId,
      mapId: "0",
      isInnerMapping: arrAssetMapping.isInnerMapping,
      fileColumn: arrAssetMapping.fileColumn,
      defaultValue: arrAssetMapping.defaultValue,
      parentMapId: this.intParentMapId,
      format: arrAssetMapping.format,
      isActive: arrAssetMapping.isActive,
      outerTableColumn: this.strAssetColumn,
      innerTableColumnText: arrAssetMapping.innerTableColumnText,
    };
    this.loading = true;
    this.assetUploadService
      .insertAssetUploadMappingData(arrInsertAssetUploadMappingData)
      .subscribe(res => {
        var intLastInsertedMapId = res.intStatus;
        this.assetInnerMapping[this.assetInnerMapping.indexOf(arrAssetMapping)].mapId = intLastInsertedMapId;
        this.loading = false;
      });
  }

  removeInnerAssetColumn(dataToRemove) {

    if (confirm("Are you sure to remove mapping?")) {
      var intMapId = dataToRemove.mapId;
      this.assetInnerMapping = this.assetInnerMapping.filter(item => item !== dataToRemove);
      var intMapId = dataToRemove.mapId;
      this.assetUploadService
        .removeAssetUpload(intMapId)
        .subscribe(resRemoveAssetUpload => {
          console.log("resRemoveAssetUpload===" + resRemoveAssetUpload);
        });
    }
  }

  onNoClick(): void {

    this.dialogRef.close();

  }
  onSave(): void {

    this.dialogRef.close({ assetInnerMapping: this.assetInnerMapping });
    alert("Inner Mapping Saved");
  }

  addHotAlert() {
    this.arrInnerAssetColumns.unshift({ value: this.hotAlert, name: this.hotAlert, description: this.hotAlert });
  }

}
